<script lang="ts">
    import { STEP_FORM_LIST } from '../constants/common';
    import { themeType as ThemeTypeEnum } from '../constants/Enums';
    import { ARROW_IMAGE } from '../constants/imgList';
    import { isParticipateActivity } from '../store/index';

    import webp from '@/actions/webp';

    export let themeType: ThemeTypeEnum = ThemeTypeEnum.WHITE;
    export let stepFormList = STEP_FORM_LIST;

    $: resolvedTheme =
        themeType === ThemeTypeEnum.NULL ? ThemeTypeEnum.WHITE : themeType;
    $: themeModifierClass = `ThemeTypeEnum--${resolvedTheme}`;
</script>

{#if resolvedTheme === ThemeTypeEnum.WHITE && !$isParticipateActivity}
    <div class="line"></div>
{/if}
<div class="main-container {themeModifierClass}
class:main-container--success={$isParticipateActivity}
">
    <div class="title"
    class:title--black={themeType === ThemeTypeEnum.BLACK}
    >Pasos para solicitar</div>
    <div class="apply-step-form"
    class:apply-step-form--black={themeType === ThemeTypeEnum.BLACK}
    >
        {#each stepFormList as step, i}
            <div class="benefit-item">
                <div class="top-image">
                    <img use:webp src={step[resolvedTheme]} alt="" loading="lazy" />
                </div>
                <div
                    class="benefit-item-title"
                    class:benefit-item-title--third={i === 2}
                >{step.title}</div>
            </div>
            {#if i < stepFormList.length - 1}
                <div class="arrow-between" aria-hidden="true">
                    <img use:webp src={ARROW_IMAGE} alt="" loading="lazy" />
                </div>
            {/if}
        {/each}
    </div>
</div>

<style lang="scss" scoped>
    .main-container {
        width: 100%;
        height: 100%;

        &.ThemeTypeEnum--BLACK {
            background-color: #1c1d1e;
            padding: 0 0 80px 0;
        }
        &.ThemeTypeEnum--WHITE {
            background-color: #ffffff;
            padding: 60px 40px 40px 40px;
        }

    }
    .main-container--success {
        padding-bottom: 60px;
    }

    .line {
        width: 100%;
        height: 20px;
        background: #f2f2f5;
    }
    .title {
        font-family: DiDiSans-Pro-Bold;
        font-size: 32px;
        line-height: 40px;
        color: #0c0c0d;
    }
    .title--black {
        margin-left: 16px;
        opacity: 0.8;
    }
    .main-container.ThemeTypeEnum--BLACK .title {
        color: #ffffff;
    }
    .apply-step-form {
        margin-top: 24px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        width: 100%;
        background-color: #ffffff;
        .benefit-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 1 1 0;
            min-width: 0;
            text-align: center;
        }
        .top-image {
            width: 108px;
            height: 108px;
            flex-shrink: 0;
            img {
                height: 100%;
                width: 100%;
                object-fit: contain;
                display: block;
            }
        }
        .benefit-item-title {
            margin-top: 12px;
            width: 156px;
            font-size: 24px;
            line-height: 28px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;

            &.benefit-item-title--third {
                width: 180px;
            }
        }
        .main-container.ThemeTypeEnum--BLACK & {
            background-color: #1c1d1e;

            .benefit-item-title {
                color: #ffffff;
            }
        }
        .arrow-between {
            flex: 0 0 32px;
            width: 32px;
            height: 108px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            img {
                width: 32px;
                height: 32px;
                object-fit: contain;
                display: block;
            }
        }
    }
    .apply-step-form--black {
        margin-top: 32px;
    }
</style>
